/**
 * @param {object} blok - object representing the Link type field from Storyblok
 * @return {string} - string with the href value of the link
 */
const determineStoryblokLink = ({ blok }) => {
  let href = '/'

  if (blok?.link?.linktype === 'asset') {
    href = blok?.link?.cached_url
  } else if (blok?.link?.linktype === 'email') {
    href = `mailto:${blok?.link?.email}`
  } else if (blok?.link?.linktype === 'story') {
    href = blok?.link?.cached_url === 'home' ? '/' : `/${blok?.link?.cached_url}/`

    // * If slug is a home page in storyblok for a route, it will already have the /
    if (href.endsWith('//')) {
      href = href.slice(0, -1)
    }

    if (blok?.link?.anchor) {
      href = `${href}#${blok?.link?.anchor}`
    }
  } else if (blok?.link?.linktype === 'url') {
    href = blok?.link?.cached_url
  }

  return href
}

export default determineStoryblokLink
